export enum StructureTypes {
    Chunk = "Chunk",
    Coloring = "Coloring",
    Section = "Section",
    Unknown = "Unknown",
}
